/* --------------------------------------------------------------------------
	Menu
-------------------------------------------------------------------------- */

	"use strict";
	var $ = jQuery;
	import { saveScrollYPosition, getScrollbarWidth, restoreScrollYPosition } from "../base/page.js";
	import '../base/swap.js';

	var $SearchMenu,
	    $SearchMenuClose,
		$SearchMenuToggle,
	    $ShiftingElements,
	    LockClass;

	function initSearchMenu() {
		$SearchMenu = $(".js-search-menu");

		if ($SearchMenu.length) {
			
			$SearchMenuToggle = $(".js-search-toggle");
			$SearchMenuClose = $(".js-search-menu-close-toggle");
			$ShiftingElements = $(".header, .page, .footer");
			LockClass = "fs-page-lock";

			$SearchMenu.find(".js-nav-link, button, input").attr("tabindex", "-1");
			$SearchMenu.on("keydown", onMenuKeydown)
				.on("keyup", onMenuKeyup)
				.attr("aria-hidden", "true");

			$SearchMenuToggle.on("activate.swap", onMenuSwapActivate)
					.on("deactivate.swap", onMenuSwapDeactivate)
					.attr({ "aria-expanded": "false", "role": "button" });

			$SearchMenuClose.on("keydown", onCloseKeydown)
					.on("click", onMenuSwapDeactivate);

			$(document).on("click touchstart", onDocumentClick);

		}
	}

	function onDocumentClick(e) {
		if ($("body").hasClass(LockClass)) {
			if (!$(e.target).closest(".js-search-menu").length) {
				$SearchMenuToggle.swap("deactivate");
			}
		}
	}

	function onMenuSwapActivate() {
		$("body").addClass(LockClass);

		saveScrollYPosition();

		$SearchMenuToggle.attr("aria-expanded", "true");

		$SearchMenu.attr({ "aria-hidden": "false", "tabindex": "0" })
		     .one('transitionend', function() { $SearchMenu.find(".site_search_input").focus(); })
		     .find(".js-nav-link, button, input").removeAttr("tabindex");

		$ShiftingElements.css("padding-right", getScrollbarWidth());

		$SearchMenu.css({
			"margin-right": "",
			"width": ""
		});
	}

	function onMenuSwapDeactivate() {
		$("body").removeClass(LockClass);

		restoreScrollYPosition();

		$SearchMenu.attr("aria-hidden", "true").removeAttr("tabindex")
		     .find(".js-nav-link, button, input").attr("tabindex", "-1");

		$SearchMenuToggle.attr("aria-expanded", "false").focus();

		$ShiftingElements.css("padding-right", "");

		$SearchMenu.css({
			"margin-right": getScrollbarWidth() * -1,
			"width": "calc(100% + " + getScrollbarWidth() + "px)"
		});
	}

	function onCloseKeydown(e) {
		// tab
		if (e.keyCode === 9) {
			if (!(e.shiftKey)) {
				$SearchMenu.focus();
			}
		}
	}

	function onMenuKeydown(e) {
		if ($SearchMenu.is(":focus")) {
			// tab
			if (e.keyCode === 9) {
				if (e.shiftKey) {
					e.preventDefault();

					$SearchMenuClose.focus();
				}
			}
		}
	}

	function onMenuKeyup(e) {
		// escape
		if (e.keyCode === 27) {
			$SearchMenuToggle.swap("deactivate");
		}
	}

	$(initSearchMenu);
